import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FileField } from '@itds/elements/index.js';

import { Colors, FontSizes } from '@itds/Theme';

const ImgExpansionCard = ({ data, file, label, onChange }) => {
  const [open, setOpen] = useState(false);

  const styles = {
    card: {
      padding: '20px',
      borderRadius: '5px',
      backgroundColor: Colors.WHITE,
      borderBottom: '1px solid #e5e5e5'
    },
    card_raised: {
      border: '1px solid #e5e5e5',
      boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
      borderRadius: '5px',
      marginBottom: '20px'
    },
    card_expandable: {
      cursor: 'pointer'
    },
    card_expandable__card__face: {
      cursor: 'pointer'
    },
    card_expandable__card__content: {
      display: 'none'
    },
    card__face: {
      display: 'flex',
      alignItems: 'center'
    },
    card__face__title: {
      fontSize: FontSizes.LARGE,
      marginRight: '30px'
    },
    card__face__status: {
      margin: 'auto 10px',
      width: '30px',
      height: '30px',
      borderRadius: '30px',
      lineHeight: '30px',
      textAlign: 'center',
      fontSize: '16px',
      backgroundColor: Colors.GRAY.hex,
      color: Colors.WHITE
    },
    card__face__status_green: {
      backgroundColor: Colors.GREEN.hex
    },
    card__face__status_red: {
      backgroundColor: Colors.RED
    },
    card__face__status_blue: {
      backgroundColor: Colors.BLUE.hex
    },
    card__face__status_yellow: {
      backgroundColor: Colors.YELLOW
    },
    card__face__meta: {
      display: 'flex',
      marginRight: '20px'
    },
    card__face__meta__item: {
      display: 'block',
      padding: '7px 10px',
      border: '1px solid #e5e5e5',
      marginLeft: '-1px'
    },
    card__face__meta__item_first_child: {
      borderRadius: '3px 0 0 3px'
    },
    card__face__meta__item_last_child: {
      borderRadius: '0 3px 3px 0'
    },
    card__face__meta__item_label: {
      display: 'block',
      marginBottom: '5px',
      fontStyle: 'italic',
      color: Colors.GRAY
    },
    card__face__meta__item_span: {
      fontWeight: '500'
    },
    card_content: {
      backgroundColor: '#f5f5f5',
      margin: '20px -20px -20px',
      padding: '20px',
      borderRadius: '0 0 5px 5px',
      borderTop: '1px solid #e5e5e5'
    },
    file_upload: {
      textTransform: 'none',
      letterSpacing: '0px',
      position: 'relative'
    },
    file_upload____btn: {
      position: 'absolute',
      top: '-7px',
      padding: '7px 11px'
    },
    img: {
      margin: '20px 0'
    },
    flex_justify: {
      justifyContent: 'space-between'
    }
  };

  const images =
    data && data.url
      ? Object.keys(data).map(key => ({
          label: key,
          url: data[key].url
        }))
      : [];

  return (
    <div style={{ ...styles.card, ...styles.card_raised, ...styles.card_expandable }}>
      <div
        onClick={setOpen.bind(null, !open)}
        style={{ ...styles.card__face, ...styles.flex_justify }}
      >
        <label style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px' }}>
          {label}{' '}
          <span
            className={`${images?.length ? 'mdi mdi-check' : 'mdi mdi-close'}`}
            style={images?.length ? { color: Colors.GREEN.hex } : { color: Colors.RED }}
          />
        </label>

        <div style={{ width: '50%' }}>
          <FileField file={file} fileUrl={data && data.url} onChange={onChange} />
        </div>
      </div>
      {open ? (
        <div style={{ ...styles.card_content, display: 'block' }}>
          <div
            style={{
              flexWrap: 'wrap',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {images?.map((image, i) => {
              return image.url ? (
                <img
                  alt='image_file'
                  key={i}
                  src={`${image.url}?t=${Date.now()}`}
                  title={image.label}
                />
              ) : null;
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

ImgExpansionCard.propTypes = {
  data: PropTypes.object,
  file: PropTypes.object,
  images: PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func
};

export default ImgExpansionCard;
